import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import * as Client from '../../data/apiClient/client';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { invoicesActionCreators } from '../../data/invoices/invoicesAction';
import { ApiInvoiceObject, ApiInvoiceRowObject, ApiInvoicesState } from '../../data/invoices/invoicesModels';
import { newsActionCreators } from '../../data/news/newsActions';
import { ApiNewsObject, ApiNewsState } from '../../data/news/newsModels';
import { opportunitiesActionCreators } from '../../data/opportuneties/opportunetisActions';
import { ApiOpportunitiesState } from '../../data/opportuneties/opportunetisModels';
import { orderActionCreators } from '../../data/order/orderActions';
import { ApiOrderObject, ApiOrderState } from '../../data/order/orderModels';
import { projectsActionCreators } from '../../data/projects/projectsAction';
import { ProjectObject, ProjectsState } from '../../data/projects/projectsModels';
import { shipmentsActionCreators } from '../../data/shipment/shipmentAction';
import { ShipmentObject, ShipmentState } from '../../data/shipment/shipmentModels';
import { userActionCreators } from '../../data/user/userActions';
import { Permissions, PermissionsObject, UserState } from '../../data/user/userModels';
import Footer from '../footer/footer';
import Header from '../header/header';
import MenuBar from '../menubar/menubar';
import './layout.css';

interface LayoutState {
    opportunities: ApiOpportunitiesState;
    projects: ProjectsState;
    news: ApiNewsState;
    header: HeaderState;
    order: ApiOrderState;
    invoices: ApiInvoicesState;
    user: UserState;
    shipment: ShipmentState;
}

interface LayoutActions {
    opportunitiesAction: typeof opportunitiesActionCreators;
    projectActions: typeof projectsActionCreators;
    newsActions: typeof newsActionCreators;
    headerActions: typeof headerActionCreators;
    orderActions: typeof orderActionCreators;
    invoicesActions: typeof invoicesActionCreators;
    userActions: typeof userActionCreators;
    shipmentActions: typeof shipmentsActionCreators;
}

type LayoutProps = LayoutState & // ... state we've requested from the Redux store
    LayoutActions &
    RouteComponentProps<{}>; // ... plus action creators we've requested

class Layout extends React.Component<LayoutProps, {}> {
    constructor(props: LayoutProps) {
        super(props);
        this.fetchOpportunities = this.fetchOpportunities.bind(this);
        this.fetchOrders = this.fetchOrders.bind(this);
        this.fetchInvoices = this.fetchInvoices.bind(this);
        this.fetchProjects = this.fetchProjects.bind(this);
        this.fetchNews = this.fetchNews.bind(this);
        this.returnCRU = this.returnCRU.bind(this);
        this.fetchShipments = this.fetchShipments.bind(this);
    }

    fetchOpportunities() {
        this.props.opportunitiesAction.GetOpportunities();
    }

    fetchOrders() {
        this.props.orderActions.setLoading(true);
        const ordersClient = new Client.OrdersClient();
        ordersClient.getAll().then((response: Client.OrderHead[]) => {
            const OrderObjects: ApiOrderObject[] = Array<any>();
            response.map((obj) => {
                // var orderObject = obj as ApiOrderObject;
                const orderObject = new ApiOrderObject(obj);
                OrderObjects.push(orderObject);
            });
            if (response !== undefined) {
                this.props.orderActions.setOrders(OrderObjects);
                this.props.orderActions.setLoading(false);
            } else {
                this.props.orderActions.setLoading(false);
            }
        });
    }

    fetchInvoices() {
        this.props.invoicesActions.setLoading(true);
        const invoicesClient = new Client.InvoicesClient();
        invoicesClient.getAll().then((response) => {
            const invoices: ApiInvoiceObject[] = Array<any>();
            response.map((obj) => {
                const invoice: ApiInvoiceObject = new ApiInvoiceObject(
                    obj.invoiceId ? obj.invoiceId : undefined,
                    obj.invoiceNumber ? obj.invoiceNumber : undefined,
                    obj.dueDate ? obj.dueDate : undefined,
                    obj.orderNumber ? obj.orderNumber : undefined,
                    obj.balance ? obj.balance : undefined,
                    obj.orderId ? obj.orderId : undefined,
                    obj.pONumber ? obj.pONumber : undefined,
                    obj.invoiceDate ? obj.invoiceDate : undefined,
                    obj.totalAmount ? obj.totalAmount : undefined,
                    obj.taxAmount ? obj.taxAmount : undefined,
                    obj.shipToName ? obj.shipToName : undefined,
                    obj.shipToAddress ? obj.shipToAddress : undefined,
                    obj.shipToCity ? obj.shipToCity : undefined,
                    obj.shipToState ? obj.shipToState : undefined,
                    obj.freightAmount ? obj.freightAmount : undefined,
                    obj.productAmount ? obj.productAmount : undefined,
                    obj.materialSurchange ? obj.materialSurchange : undefined,
                    obj.miscChanges ? obj.miscChanges : undefined,
                    obj.invoiceRows
                        ? obj.invoiceRows.map((x) => {
                              return new ApiInvoiceRowObject(
                                  x.lineNumber ? x.lineNumber : undefined,
                                  x.itemNumber ? x.itemNumber : undefined,
                                  x.orderedQty ? x.orderedQty : undefined,
                                  x.deliveredQty ? x.deliveredQty : undefined,
                                  x.backorderQty ? x.backorderQty : undefined,
                                  x.unitPrice ? x.unitPrice : undefined,
                                  x.discount ? x.discount : undefined,
                                  x.amount ? x.amount : undefined,
                                  x.description ? x.description : undefined
                              );
                          })
                        : undefined,
                    obj.customerName,
                    obj.address,
                    obj.city,
                    obj.state,
                    obj.country
                );
                invoices.push(invoice);
            });
            if (response !== undefined) {
                this.props.invoicesActions.setInvoices(invoices);
                this.props.orderActions.setLoading(false);
            } else {
                this.props.orderActions.setLoading(false);
            }
        });
    }

    fetchShipments() {
        this.props.shipmentActions.setLoading(true);
        const shipmentClient = new Client.ShipmentsClient();
        const shipments: ShipmentObject[] = Array<any>();
        shipmentClient.getAll().then((response) => {
            response.map((obj) => shipments.push(obj));

            if (response !== undefined) {
                this.props.shipmentActions.setShipments(shipments);
                this.props.shipmentActions.setLoading(false);
            } else {
                this.props.shipmentActions.setLoading(false);
            }
        });

        /*
        shipmentClient.get().then((response) => {
            const shipments: ShipmentObject[] =  Array<any>();
            response.map((obj) => {
                shipments.push(
                    new ShipmentObject(
                        obj.shipmentId ? obj.shipmentId : undefined,
                        obj.orderId ? obj.orderId : undefined,
                        obj.shipDate ? obj.shipDate : undefined,
                        obj.orderNumber ? obj.orderNumber : undefined,
                        obj.pONumber ? obj.pONumber : undefined,
                        obj.carrier ? obj.carrier : undefined,
                        obj.trackNumber ? obj.trackNumber : undefined,
                        obj.trackLink ? obj.trackLink : undefined,
                        obj.freightCharge ? obj.freightCharge : undefined,
                        obj.shipToName ? obj.shipToName : undefined,
                        obj.shipToAddress ? obj.shipToAddress : undefined,
                        obj.shipToCity ? obj.shipToCity : undefined,
                        obj.shipToState ? obj.shipToState : undefined,
                        obj.details
                            ? obj.details.map((detail: Client.ShipmentDetail) => {
                                  return new ShipmentDetailObject(
                                      detail.packSlip,
                                      detail.palletID,
                                      detail.itemNumber,
                                      detail.quantity,
                                      detail.description
                                  );
                              })
                            : undefined
                    )
                );
            });
            if (response !== (null || undefined)) {
                this.props.shipmentActions.setShipments(shipments);
                this.props.shipmentActions.setLoading(false);
            } else {
                this.props.shipmentActions.setLoading(false);
            }
        });
        */
    }

    fetchProjects() {
        this.props.projectActions.setLoading(true);
        const projectsClient = new Client.ProjectsClient();
        projectsClient.get().then((response) => {
            const projects: ProjectObject[] = Array<any>();
            response.map((obj) => {
                projects.push(
                    new ProjectObject(
                        obj.name ? obj.name : undefined,
                        obj.projectStatus ? obj.projectStatus : undefined,
                        obj.estCompletionDate ? obj.estCompletionDate : undefined,
                        obj.projectNumber ? obj.projectNumber : undefined
                    )
                );
            });
            if (response !== (null || undefined)) {
                this.props.projectActions.setProjects(projects);
                this.props.projectActions.setLoading(false);
            } else {
                this.props.projectActions.setLoading(false);
            }
        });
    }

    fetchInternalNews() {
        this.props.newsActions.setLoadingInternal(true);
        const newsClient = new Client.NewsClient();
        newsClient.getInternal().then((response) => {
            const filterdNews: ApiNewsObject[] = Array<any>();
            response.map((obj) => {
                filterdNews.push({
                    description: obj.description ? obj.description : '',
                    publishDate: obj.publishDate ? obj.publishDate : new Date(),
                    topic: obj.topic ? obj.topic : '',
                    url: obj.url ? obj.url : '',
                    attachmentExists: obj.attachmentExists ? obj.attachmentExists : false,
                    attachmentId: obj.attachmentId ? obj.attachmentId : '',
                    newsId: obj.newsId ? obj.newsId : ''
                } as ApiNewsObject);
            });
            if (response !== (null || undefined)) {
                this.props.newsActions.addNewsInternal(filterdNews);
                this.props.newsActions.setLoadingInternal(false);
            } else {
                this.props.newsActions.setLoadingInternal(false);
            }
        });
    }

    fetchNews() {
        this.props.newsActions.setLoading(true);
        const newsClient = new Client.NewsClient();
        newsClient.get().then((response) => {
            const filterdNews: ApiNewsObject[] = Array<any>();
            response.map((obj) => {
                if (
                    obj.description !== null &&
                    obj.description !== undefined &&
                    obj.publishDate !== null &&
                    obj.publishDate !== undefined &&
                    obj.topic !== null &&
                    obj.topic !== undefined &&
                    obj.url !== null &&
                    obj.url !== undefined
                ) {
                    filterdNews.push({
                        description: obj.description,
                        publishDate: obj.publishDate ? obj.publishDate : new Date(),
                        topic: obj.topic,
                        url: obj.url,
                        attachmentExists: obj.attachmentExists ? obj.attachmentExists : false,
                        attachmentId: obj.attachmentId ? obj.attachmentId : '',
                        newsId: obj.newsId ? obj.newsId : ''
                    } as ApiNewsObject);
                }
            });
            if (response !== (null || undefined)) {
                this.props.newsActions.addNews(filterdNews);
                this.props.newsActions.setLoading(false);
            } else {
                this.props.newsActions.setLoading(false);
            }
        });
    }

    returnCRU(object: Client.Privelege | undefined) {
        const CRU = new PermissionsObject();
        if (object) {
            object.create ? (CRU.create = object.create) : (CRU.create = false);
            object.read ? (CRU.read = object.read) : (CRU.read = false);
            object.update ? (CRU.update = object.update) : (CRU.update = false);
            return CRU;
        } else {
            CRU.create = false;
            CRU.read = false;
            CRU.update = false;
            return CRU;
        }
    }

    componentWillMount() {
        const userClient = new Client.UserClient();
        userClient.get().then((response) => {
            const permissions = new Permissions();
            permissions.duct = this.returnCRU(response.duct);
            permissions.news = this.returnCRU(response.news);
            permissions.orders = this.returnCRU(response.orders);
            permissions.resourceTraining = this.returnCRU(response.resourceTraining);
            permissions.invoices = this.returnCRU(response.invoices);
            permissions.quickTickOnline = this.returnCRU(response.quickTickOnline);
            permissions.opportunities = this.returnCRU(response.opportunities);
            permissions.fullAccess = this.returnCRU(response.fullAccess);
            permissions.qfv = this.returnCRU(response.qFV);
            this.props.userActions.setPermissions(permissions);
            if (permissions.news.read) {
                this.fetchNews();
                this.fetchInternalNews();
            }
            if (permissions.orders.read) {
                this.fetchOrders();
                this.fetchShipments();
            }
            if (permissions.invoices.read) {
                this.fetchInvoices();
            }
            if (permissions.opportunities.read) {
                this.fetchOpportunities();
            }
            if (permissions.duct.read) {
                this.fetchProjects();
            }
            if (response.firstName) {
                this.props.userActions.setFirstName(response.firstName);
            }
            if (response.lastName) {
                this.props.userActions.setLastName(response.lastName);
            }
            if (response.contactEmailAddress) {
                this.props.userActions.setContactEmail(response.contactEmailAddress);
            }
            if (response.crmUserId) {
                this.props.userActions.setCrmUserId(response.crmUserId);
            }
            if (response.error) {
                this.props.userActions.setError(response.error);
            }
            if (response.errorMessage) {
                this.props.userActions.setErrorMessage(response.errorMessage);
            }
            if (response.customerInformation) {
                this.props.userActions.setCustomerData(response.customerInformation);
            }
        });
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="wrapper">
                    <div className="row">
                        <Header />
                        <MenuBar />
                    </div>
                    <div className="contentBody">{this.props.children}</div>
                </div>
                <div className="row">
                    <Footer />
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): LayoutState {
    return {
        opportunities: state.opportunities,
        projects: state.projects,
        news: state.news,
        header: state.header,
        order: state.order,
        invoices: state.invoices,
        user: state.user,
        shipment: state.shipments
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): LayoutActions {
    return {
        opportunitiesAction: bindActionCreators(opportunitiesActionCreators, dispatch),
        projectActions: bindActionCreators(projectsActionCreators, dispatch),
        newsActions: bindActionCreators(newsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        orderActions: bindActionCreators(orderActionCreators, dispatch),
        invoicesActions: bindActionCreators(invoicesActionCreators, dispatch),
        userActions: bindActionCreators(userActionCreators, dispatch),
        shipmentActions: bindActionCreators(shipmentsActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Layout)
);



// WEBPACK FOOTER //
// ./src/containers/layout/layout.tsx